import { render, staticRenderFns } from "./BornDate.vue?vue&type=template&id=0b972174"
import script from "./BornDate.vue?vue&type=script&lang=ts"
export * from "./BornDate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports